<label class="form-control-label" [for]="for">
  <div class="ds-fine-print form-control-label__text">{{ label }}</div>
</label>
